import { PanelType } from '@fluentui/react';
import { MessageBar, MessageBarType } from 'office-ui-fabric-react/lib/MessageBar';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataOperation_CycleOperation } from '../../data/DataOperation_CycleOperation';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxMotifArchivage } from '../ComboBox/ComboBoxMotifArchivage';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { EUIPanel } from '../EUI/EUIPanel';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { HintVerticalPosition, HintWrapper } from '../Outils/HintWrapper';
import { MessageBars } from '../Outils/MessageBars';

export class FicheValidationCycleOperation extends Component {

    static defaultProps = {
        idOperation: undefined,
        idCycleOperation: undefined,
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onSave: () => null
    };

    static defaultState = {
        cycleOperation: {},
        operation: {},
        operationCycleOperation: {},
        periodeOuverture: {},
        onActiveBoutonEnregistrer: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheValidationCycleOperation.defaultState };
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du cycle de l\'opération'
        });

        const { idCycleOperation, idOperation } = this.props;

        DataOperation_CycleOperation._chargementCycleOperation(idCycleOperation, idOperation).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;

                let operation = objetData[1];
                operation.archivageCG = operation.estArchiveeCG = operation.dateArchivageCG !== null; //MG - 2377

                const state = {
                    cycleOperation: objetData[0],
                    operation,
                    operationCycleOperation: objetData[3],
                    periodeOuverture: objetData[2],
                };

                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, state, this._onVerificationFormulaire);
            }
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _onVerificationFormulaire() {
        const { idCycleOperation } = this.props;
        const item = { ...this.state.operation, idCycleOperation }
        Immocom.fiche()._validationFormulaire(this, 'CycleOperation', item, 'Modification');
    };

    _onEnregistrement = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du cycle de l\'opération'
        });

        const { idCycleOperation, idOperation } = this.props;
        const { operation } = this.state;

        DataOperation_CycleOperation._enregistrementCycleOperation(idCycleOperation, idOperation, operation).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this.props.onSave);
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _onCheckArchiverCG = (isChecked) => {
        let operationTrav = { ...this.state.operation };
        var dateArchivageCG = Scriba.date().getChaineISOFromDate(new Date(Date.now()));
        operationTrav.dateArchivageCG = (this.state.cycleOperation.idCycleOperation === 100 ? (this.state.periodeOuverture !== null ? dateArchivageCG : null) : null);
        operationTrav.archivageCG = operationTrav.estArchiveeCG = isChecked; //MG - 2377

        this.setState({ operation: operationTrav },
            this._onVerificationFormulaire
        );
    };

    _onDismiss = () => {
        this.setState({ ...FicheValidationCycleOperation.defaultState });
        this.props.onDismiss();
    };

    _onOpen = () => {
        this._chargementDonnees();
    };

    _onSelectDate = (champs) => (event) => {
        const operation = { ...this.state.operation };
        const newDate = Scriba.date().getChaineISOFromDate(event, true);
        operation[champs] = newDate;

        this.setState(
            { operation: operation },
            this._onVerificationFormulaire
        );
    };

    _onChangeCombobox = (champs) => (event, option, index, value) => {
        let operation = { ...this.state.operation };
        operation[champs] = option.key

        this.setState(
            { operation },
            this._onVerificationFormulaire
        );
    };

    render = () => {

        const { isOpen } = this.props;
        const { cycleOperation, onActiveBoutonEnregistrer, operation, periodeOuverture } = this.state;

        const estCycleProgramme = this.props.idCycleOperation <= 40;
        const estCycleValideCG = this.state.operationCycleOperation && !!this.state.operationCycleOperation.dateValidationCG;
        const aujourdhui = new Date(Date.now());
        const existePeriodeOuverte = (periodeOuverture !== null);
        const dateDebutPeriode = (existePeriodeOuverte ? new Date(periodeOuverture.annee, new Date(periodeOuverture.dateDebut).getMonth(), 1) : null);
        const operationClotureeCG = (operation.dateClotureCG !== null);
        const infoSurvolDisabledCG = "Cette date n'est pas modifiable si l'opération est clôturée CG ou si la date renseignée est antérieure à la date de début de période CG";
        const infoDateLieeAuProgramme = "Cette date ne peut être modifiée que depuis l'identification programme";
        const infoDateLieeALaTrancheTravaux = "Cette date ne peut être modifiée que depuis la fiche tranche travaux";

        let headerText = "Valider le cycle";
        if (!!cycleOperation.libelle) headerText += ` « ${cycleOperation.libelle} »`;

        return <EUIPanel
            headerText={headerText}
            isFormValid={onActiveBoutonEnregistrer}
            isOpen={isOpen}
            onDismiss={this._onDismiss}
            onOpen={this._onOpen}
            onSave={!estCycleProgramme && !estCycleValideCG && this._onEnregistrement}
            type={PanelType.medium}
        >

            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {estCycleProgramme &&
                <MessageBar isMultiline messageBarType={MessageBarType.info}>
                    Ce cycle ne peut être validé que depuis l'identification programme
                </MessageBar>
            }

            {!estCycleProgramme && estCycleValideCG &&
                <MessageBar isMultiline messageBarType={MessageBarType.info}>
                    Ce cycle ne peut être modifié car il a été validé par le contrôle de gestion
                </MessageBar>
            }

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            {!!cycleOperation.descriptif && <div className="zoneDescriptifCycle">{cycleOperation.descriptif}</div>}

            {cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled
                    isRequired
                    label="Date perspective"
                    title="Cette date ne peut être modifiée"
                    value={operation.datePerspective}
                />
            }

            {cycleOperation.idCycleOperation >= 20 && cycleOperation.idCycleOperation <= 90 &&
                <Toggle
                    label="Bilan financier disponible"
                    onText="Oui"
                    offText="Non"
                    checked={operation.bilanFinancierDisponible}
                    onChange={(e, isChecked) => Scriba.state().setObjetPropriete(this, "operation", "bilanFinancierDisponible", isChecked)}
                />
            }

            {cycleOperation.idCycleOperation >= 20 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled
                    isRequired
                    label="Date développement"
                    title={infoDateLieeAuProgramme}
                    value={operation.dateDeveloppement}
                />
            }

            {cycleOperation.idCycleOperation >= 30 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled
                    isRequired
                    label="Date accord comité promesse"
                    title={infoDateLieeAuProgramme}
                    value={operation.dateAccordComitePromesse}
                />
            }

            {cycleOperation.idCycleOperation >= 30 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled
                    isRequired
                    label="Date signature promesse"
                    title={infoDateLieeAuProgramme}
                    value={operation.dateSignaturePromesse}
                />
            }

            {cycleOperation.idCycleOperation >= 30 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled
                    isRequired={cycleOperation.idCycleOperation == 30 || !operation.dateSignaturePromesseFinValidite}
                    label="Date signature promesse fin de validité prévue"
                    title={infoDateLieeAuProgramme}
                    value={operation.dateSignaturePromesseFinValiditePrevue}
                />
            }

            {cycleOperation.idCycleOperation >= 30 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    isRequired={!operation.dateSignaturePromesseFinValiditePrevue}
                    disabled
                    label="Date signature promesse fin de validité"
                    title={infoDateLieeAuProgramme}
                    value={operation.dateSignaturePromesseFinValidite}
                />
            }

            {cycleOperation.idCycleOperation >= 30 && cycleOperation.idCycleOperation <= 40 &&
                <HintWrapper
                    content={<span>Plus petite date prévisionnelle de commercialisation parmi toutes les opérations du programme</span>}
                    verticalAlign={HintVerticalPosition.bottom}
                    verticalOffset={5}
                >
                    <EUIDatePicker
                        disabled={operationClotureeCG || (operation.dateLancementCommercialisationPrevue && new Date(operation.dateLancementCommercialisationPrevue) < dateDebutPeriode)}
                        isRequired
                        label="Date lancement commercialisation prévue"
                        maxDate={aujourdhui}
                        minDate={existePeriodeOuverte ? dateDebutPeriode : null}
                        onSelectDate={this._onSelectDate('dateLancementCommercialisationPrevue')}
                        title={infoSurvolDisabledCG}
                        value={operation.dateLancementCommercialisationPrevue}
                    />
                </HintWrapper>
            }

            {cycleOperation.idCycleOperation >= 50 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled={operationClotureeCG || (operation.dateLancementCommercialisation && new Date(operation.dateLancementCommercialisation) < dateDebutPeriode)}
                    isRequired
                    label="Date lancement commercialisation"
                    maxDate={aujourdhui}
                    minDate={existePeriodeOuverte ? dateDebutPeriode : null}
                    onSelectDate={this._onSelectDate('dateLancementCommercialisation')}
                    title={infoSurvolDisabledCG}
                    value={operation.dateLancementCommercialisation}
                />
            }

            {cycleOperation.idCycleOperation >= 40 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled
                    isRequired
                    label="Date accord comité achat terrain"
                    title={infoDateLieeAuProgramme}
                    value={operation.dateAccordComiteAchatTerrain}
                />
            }

            {cycleOperation.idCycleOperation >= 40 && cycleOperation.idCycleOperation <= 50 &&
                <EUIDatePicker
                    disabled
                    isRequired
                    label="Date achat terrain prévue"
                    title={infoDateLieeAuProgramme}
                    value={operation.dateAchatTerrainPrevue}
                />
            }

            {cycleOperation.idCycleOperation >= 40 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled
                    isRequired
                    label="Date achat terrain"
                    title={infoDateLieeAuProgramme}
                    value={operation.dateAchatTerrain}
                />
            }

            {cycleOperation.idCycleOperation >= 40 && cycleOperation.idCycleOperation <= 60 &&
                // KP - 23/05/2023 - 2387 : Pour activer le cycle Pré-com foncier non engagé et Pré-com foncier engagé la date obtention PC prévisonnelle devient obligatoire, la réelle n'est plus obligatoire.
                <EUIDatePicker
                    disabled
                    isRequired={cycleOperation.idCycleOperation === 50 || cycleOperation.idCycleOperation === 60}
                    label="Date obtention PC prévue"
                    title={infoDateLieeALaTrancheTravaux}
                    value={operation.dateObtentionPCPrevue}
                />
            }

            {cycleOperation.idCycleOperation >= 70 && cycleOperation.idCycleOperation <= 90 &&
                // KP - 23/05/2023 - 2387 : Pour activer le cycle Pré-com foncier non engagé et Pré-com foncier engagé la date obtention PC prévisonnelle devient obligatoire, la réelle n'est plus obligatoire.
                // KP - 14/06/2023 - 2387 (retour) : il faut aussi enlever le caractère obligatoire de la date [réelle] dans le cycle 4
                <EUIDatePicker
                    disabled
                    isRequired={cycleOperation.idCycleOperation >= 70}
                    label="Date obtention PC"
                    title={infoDateLieeALaTrancheTravaux}
                    value={operation.dateObtentionPC}
                />
            }

            {cycleOperation.idCycleOperation >= 70 && cycleOperation.idCycleOperation <= 90 &&
                // KP - 23/05/2023 - 2387 : Pour activer le cycle Pré-com foncier non engagé et Pré-com foncier engagé la date obtention PC prévisonnelle devient obligatoire, la réelle n'est plus obligatoire.
                <EUIDatePicker
                    disabled
                    isRequired
                    label="Date purge PC"
                    title={infoDateLieeALaTrancheTravaux}
                    value={operation.datePurgePC}
                />
            }

            {cycleOperation.idCycleOperation >= 70 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled
                    isRequired
                    label="Date accord comité lancement des travaux"
                    title={infoDateLieeALaTrancheTravaux}
                    value={operation.dateAccordComiteLancementTravaux}
                />
            }

            {cycleOperation.idCycleOperation === 70 &&
                <EUIDatePicker
                    disabled
                    isRequired={!operation.dateSignatureOSTravaux}
                    label="Date signature OS travaux prévue"
                    title={infoDateLieeALaTrancheTravaux}
                    value={operation.dateSignatureOSTravauxPrevue}
                />
            }

            {cycleOperation.idCycleOperation >= 70 && cycleOperation.idCycleOperation <= 90 &&
                <EUIDatePicker
                    disabled
                    isRequired={(cycleOperation.idCycleOperation === 70 && !operation.dateSignatureOSTravauxPrevue) || cycleOperation.idCycleOperation > 70}
                    label="Date signature OS travaux"
                    title={infoDateLieeAuProgramme}
                    value={operation.dateSignatureOSTravaux}
                />
            }

            {cycleOperation.idCycleOperation === 90 &&
                <EUIDatePicker
                    disabled={operationClotureeCG || (operation.dateLivraison && new Date(operation.dateLivraison) < dateDebutPeriode)}
                    isRequired
                    label="Date livraison"
                    maxDate={aujourdhui}
                    minDate={existePeriodeOuverte ? dateDebutPeriode : null}
                    onSelectDate={this._onSelectDate('dateLivraison')}
                    title={infoSurvolDisabledCG}
                    value={operation.dateLivraison}
                />
            }

            {cycleOperation.idCycleOperation === 100 &&
                <Toggle
                    data-testid="toggleArchivageCG"
                    label="Archiver CG"
                    onText="Oui"
                    offText="Non"
                    disabled={!existePeriodeOuverte || periodeOuverture.mois !== "janvier"}
                    checked={operation.archivageCG}
                    onChange={(e, isChecked) => this._onCheckArchiverCG(isChecked)}
                />
            }

            {cycleOperation.idCycleOperation === 110 &&
                <ComboBoxMotifArchivage
                    disabled={!existePeriodeOuverte || periodeOuverture.mois !== "janvier"}
                    onChange={this._onChangeCombobox("idMotifArchivage")}
                    required
                    selectedKey={operation.idMotifArchivage}
                />
            }

        </EUIPanel>;

    };

};